import axios from '@/plugins/axios';

const exploreUrl = '/api/explore';

export const fetchExplore = async (filters) => {
    const response = await axios.get(exploreUrl + '?' + new URLSearchParams(filters).toString());
    return response;
}

export const filterByLLMs = async () => {
    const response = await axios.get(`${exploreUrl}/filter/llms`);
    return response;
}

export const filterBySellerBadges = async () => {
    const response = await axios.get(`${exploreUrl}/filter/seller-badges`);
    return response;
}

export const filterByEvalScoreRange = async () => {
    const response = await axios.get(`${exploreUrl}/filter/eval-score-range`);
    return response;
}

export const filterByEvalAverageDifficulty = async () => {
    const response = await axios.get(`${exploreUrl}/filter/eval-average-difficulty`);
    return response;
}

export const filterByEvalRunTimeMax = async () => {
    const response = await axios.get(`${exploreUrl}/filter/eval-run-time-max`);
    return response;
}

export const filterByEvalTotalTasks = async () => {
    const response = await axios.get(`${exploreUrl}/filter/eval-total-tasks`);
    return response;
}

export const filterByEvalCostPerRun = async () => {
    const response = await axios.get(`${exploreUrl}/filter/eval-cost-per-run`);
    return response;
}

export const filterByEvalModelName = async () => {
    const response = await axios.get(`${exploreUrl}/filter/eval-model-name`);
    return response;
}

export const filterByTags = async () => {
    const response = await axios.get(`${exploreUrl}/filter/tags`);
    return response;
}

export const fetchTagTypes = async () => {
    const response = await axios.get(`${exploreUrl}/filter/tag-types`);
    return response;
}
    
export const filterByTagTypes = async (tagType) => {
    const response = await axios.post(`${exploreUrl}/filter/tag-types`, { tag_type: tagType });
    return response;
}

export const filterByBadges = async () => {
    const response = await axios.get(`${exploreUrl}/filter/badges`);
    return response;
}

export const fetchLLMs = async () => {
    const response = await axios.get('/api/explore/filter/llms');
    return response;
}
